import React from 'react';
import { TrendingUp, DollarSign, Award, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Benefits = () => {
  const { t } = useLanguage();

  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-black via-cyan-950/10 to-black relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(1,137,196,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(1,137,196,0.03)_1px,transparent_1px)] bg-[size:50px_50px]" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Transparency Section */}
        <div className="mb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-cyan-600 to-blue-600 p-3 flex items-center justify-center">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                  {t.benefits.transparency.title}
                </h2>
              </div>
              <p className="text-gray-400 text-lg mb-6">
                {t.benefits.transparency.description}
              </p>
            </div>
            <div className="bg-gradient-to-br from-cyan-950/50 to-blue-950/30 border border-cyan-500/30 rounded-lg p-8">
              <ul className="space-y-4">
                {t.benefits.transparency.points.map((point, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-200 text-lg">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Affordable Section */}
        <div className="mb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-lg blur opacity-25 group-hover:opacity-40 transition duration-300" />
                <div className="relative bg-gradient-to-br from-blue-950/50 to-cyan-950/30 border border-cyan-500/30 rounded-lg p-8">
                  <p className="text-gray-200 text-lg leading-relaxed">
                    {t.benefits.affordable.description}
                  </p>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-blue-600 to-cyan-600 p-3 flex items-center justify-center">
                  <DollarSign className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-500 bg-clip-text text-transparent">
                  {t.benefits.affordable.title}
                </h2>
              </div>
            </div>
          </div>
        </div>

        {/* Certification Section */}
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-cyan-600 to-sky-600 p-3 flex items-center justify-center">
                  <Award className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-sky-500 bg-clip-text text-transparent">
                  {t.benefits.certification.title}
                </h2>
              </div>
              <p className="text-gray-400 text-lg mb-6">
                {t.benefits.certification.description}
              </p>
            </div>
            <div className="bg-gradient-to-br from-cyan-950/50 to-sky-950/30 border border-cyan-500/30 rounded-lg p-8">
              <ul className="space-y-4">
                {t.benefits.certification.points.map((point, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-200 text-lg">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
